import apiClient from "@/app/api/client";
import { reportsEndpoints } from "@/app/api/endpoints";
import type {
	BrigadeRatingsApiResponse,
	BrigadeRatingsData,
	DashboardApiResponse,
	DashboardData,
	DashboardQuery,
} from "@/app/api/types";

export const dashboardService = {
	async getStats(params: DashboardQuery): Promise<DashboardData> {
		const response = await apiClient.get<DashboardApiResponse>(reportsEndpoints.dashboard, {
			params,
		});
		return response.data.data;
	},
	async getBrigadeRatings(organizationId: string): Promise<BrigadeRatingsData> {
		const response = await apiClient.get<BrigadeRatingsApiResponse>(
			reportsEndpoints.brigadeRatings,
			{ params: { organizationId } }
		);
		return response.data.data;
	},
};
